import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const STATUS_MAPPING_OPTIONS = [
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'Tentative', value: 'TENTATIVE' },
  { label: 'Waitlisted', value: 'WAITLISTED' },
  { label: 'Enquiry', value: 'ENQUIRY' },
  { label: 'Awaiting Confirmation', value: 'AWAITING_CONFIRMATION' },
];

export const AddEditStatusMappingsForm = (_strings?: any): FormModel[] => {
  return [
    {
      label: 'BBR Status',
      value: '',
      size: 'medium',
      type: 'select',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'Select BBR status',
      field: 'status',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: STATUS_MAPPING_OPTIONS,
    },
    {
      label: 'IDS Status Name',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS status name',
      field: 'statusName',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: 'IDS Status Code',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS status code',
      field: 'statusCode',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
